import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const Logout = () => {
    const [loggedOut, setLoggedOut] = useState(false);

    useEffect(() => {
        localStorage.removeItem('fw_user');
        localStorage.removeItem('echo_user');
        localStorage.removeItem('echo_user_account_type');
        setLoggedOut(true);
    }, []);

    if (loggedOut) {
        window.location.href = '/login';
    }

    return null;
};

export default Logout;
